(() => {
  'use strict';

  const TABLE_SELECTOR = '.openingstijden-tabel';
  const TIME_ZONE = 'Europe/Amsterdam';

  function normalise(value) {
    return String(value || '')
      .trim()
      .toLocaleLowerCase('nl-NL')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z]/g, '');
  }

  function currentWeekday() {
    try {
      return normalise(new Intl.DateTimeFormat('nl-NL', {
        weekday: 'long',
        timeZone: TIME_ZONE
      }).format(new Date()));
    } catch (error) {
      return ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'][new Date().getDay()];
    }
  }

  function highlightToday(table) {
    if (!(table instanceof HTMLTableElement)) return;

    const today = currentWeekday();
    const rows = table.querySelectorAll('tbody tr');

    rows.forEach((row) => {
      row.classList.remove('highlight-row', 'is-today');
      row.removeAttribute('aria-current');

      const dayCell = row.querySelector('th, td');
      const day = normalise(dayCell?.textContent);

      if (day === today) {
        row.classList.add('is-today');
        row.setAttribute('aria-current', 'date');
      }
    });
  }

  function init(scope = document) {
    if (!(scope instanceof Document || scope instanceof Element)) return;

    if (scope instanceof Element && scope.matches(TABLE_SELECTOR)) {
      highlightToday(scope);
    }

    scope.querySelectorAll?.(TABLE_SELECTOR).forEach(highlightToday);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
